import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TextAlignment,
} from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2, LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../../context/portal-context';
import { NewCarCommercial } from '@volkswagen-onehub/icons-core';
import { HelpContainer } from '../components/help-container';

export const LcvLayer: React.FC<{
	isVisible: boolean;
	setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
	layerRef: React.RefObject<LayerHandleV2<any>>;
}> = ({ isVisible, setIsVisible, layerRef }) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);

	const handleClose = () => {
		setIsVisible(false);
		if (layerRef?.current) {
			layerRef?.current.close();
			return ((layerRef.current as any) = null);
		}
		return null;
	};

	const renderLcvLayer = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<Container
					horizontalAlign={'flex-end'}
					padding={{
						top: ContainerPadding.dynamic0100,
						right: {
							[Breakpoints.default]: ContainerPadding.grid001,
							[Breakpoints.b1600]: ContainerPadding.dynamic0100,
						},
						bottom: ContainerPadding.dynamic0100,
					}}
				>
					<CTA
						tag="button"
						emphasis="tertiary"
						onClick={handleClose}
						aria-label="Cerrar"
						icon={<Close variant="default" aria-hidden />}
					/>
				</Container>
				<Container
					gutter={ContainerGutter.static300}
					padding={ContainerPadding.grid001}
					wrap="always"
					horizontalAlign={'center'}
				>
					<Container horizontalAlign={'center'} padding={{ bottom: ContainerPadding.dynamic0020 }}>
						<NewCarCommercial variant="large" />
					</Container>
					<Text textAlign={TextAlignment.center}>
						¡Parece que tienes una furgo Volkswagen! Si es así, te esperan muchas ventajas en la comunidad The
						Originals.
					</Text>
					<Container horizontalAlign={'center'} padding={{ bottom: ContainerPadding.dynamic0020 }}>
						<CTA
							onClick={() => {
								window.location.href =
									'https://www.volkswagen-comerciales.es/es/the-originals/descubre-the-originals.html';
							}}
							tag="button"
							emphasis="primary"
						>
							Ir a The Originals
						</CTA>
					</Container>
					<Container horizontalAlign={'center'} padding={{ bottom: ContainerPadding.dynamic0100 }}>
						<HelpContainer />
					</Container>
				</Container>
			</PortalContext.Provider>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!layerRef.current && isVisible) {
			const layer = layerManager.openFocusLayer(
				renderLcvLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(layerRef.current as any) = layer;
		}
		return null;
	};

	return <>{isVisible && renderInteractionLayer()}</>;
};
